module.exports = __webpack_public_path__ + "static/media/content_4.61670805.png";